import {
  Component,
  OnInit,
  AfterViewInit,
  ViewChild,
  OnDestroy,
  ElementRef,
  Renderer2,
  ViewChildren,
  QueryList,
  Output,
  Input,
  TemplateRef,
  HostListener,
  Inject,
} from '@angular/core';
import {DeactivationGuarded} from 'src/app/core/guards/confirm-deactivate.guard';
import {ApiService} from 'src/app/core/services/api.service';
import {ProcedureService} from './../../../../../../core/services/procedure.service';
import {
  MatDialogRef,
  MatDialog,
  MatExpansionPanel,
  MatTableDataSource,
  MatSort,
  MatSelect,
  MAT_DIALOG_DATA,
} from '@angular/material';
import {NotificationService} from 'src/app/core/services/notification.service';
import {Message} from 'src/app/core/class/message';
import {ToastrService} from 'ngx-toastr';
import {CommonService} from 'src/app/core/services/common.service';
import {WarningComponent} from 'src/app/shared/components/warning/warning.component';
import { FormControl, NgForm, FormGroup, Validators } from '@angular/forms';
import { first, map, takeUntil, filter, delay } from 'rxjs/operators';
import {Subject, ReplaySubject, BehaviorSubject, fromEvent, of} from 'rxjs';
import {Subscription} from 'rxjs/Subscription';
import {BaseComponent} from 'src/app/shared/components/base/base.component';
import {Observable} from 'rxjs/Observable';
import {NzConfigService} from 'ng-zorro-antd/core';
import {NzModalService} from 'ng-zorro-antd/modal';
import {CustomerService} from 'src/app/core/services/customer.service';
import {DocumentCustomerEntity} from 'src/app/core/class/document-customer-entity';
import {DocumentEntity} from 'src/app/core/class/DocumentEntity';
import {EnterpriseEntity} from 'src/app/core/class/enterpriseEntity';
import {CreateContractService} from 'src/app/core/services/create-contract.service';
import {UserEntity} from 'src/app/core/class/UserEntity';
import {DocumentService} from 'src/app/core/services/document.service';
import {EventEmitter} from '@angular/core';
import {AutoEnterpriseService} from 'src/app/core/services/auto-enterprise.service';
import {AddCustomerDialogComponent} from '../../customer/customer/add-customer/add-customer-dialog/add-customer-dialog.component';
import {
  EnumContractEnterpriseStatus,
  EnumContractUserRole,
} from 'src/app/core/constants/contract';
import {AutoUserService} from 'src/app/core/services/auto-user.service';
import {ActivatedRoute} from '@angular/router';
import {EnterpriseService} from 'src/app/core/services/enterprise.service';
import { stringToUTF8String } from 'src/assets/js/pdf.worker-2.6.423';
import { UserGroupService } from 'src/app/core/services/user-group.service';
import { NzFormatBeforeDropEvent, NzFormatEmitEvent } from 'ng-zorro-antd';

@Component({
  selector: 'app-edit-procedure',
  templateUrl: './edit-procedure.component.html',
  styleUrls: ['./edit-procedure.component.scss']
})
export class EditProcedureComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy, DeactivationGuarded {
  constructor(
    private documentService: DocumentService,
    private apiService: ApiService,
    private el: ElementRef,
    private createContractService: CreateContractService,
    private proService: ProcedureService,
    public dialogRef: MatDialogRef<EditProcedureComponent>,
    private dialog: MatDialog,
    public notificationService: NotificationService,
    public message: Message,
    private toastr: ToastrService,
    public commonService: CommonService,
    private renderer: Renderer2,
    private modelService: NzModalService,
    private nzConfigService: NzConfigService,
    private customerService: CustomerService,
    public autoUserService: AutoUserService,
    private route: ActivatedRoute,
    private enterpriseService: EnterpriseService,
    public autoEnterpriseService: AutoEnterpriseService,
    private sv: UserGroupService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    super(commonService, message);
    this.createContractService.resetData();
    this.subscribeIsValidNoUserExist = new BehaviorSubject<boolean>(false);
    this.subscribeIsInvalidSetPartyFlow = new BehaviorSubject<boolean>(false);
    this.subscribeIsNotAttestedInvalidSetCreatedSideParty = new BehaviorSubject<boolean>(false);
    dialogRef.disableClose = true;
    dialogRef.backdropClick().subscribe((_) => {
      this.onNoClick();
    });
    this.route.queryParams.subscribe((queryParams) => {
      if (queryParams.flagCopy) {
        this.flagCopy = true;
      }
    });
    this.procedure.type = String(this.procedure.type)
    this.isNotAttestedUser = this.commonService.checkEnterpriseType();
    this.scopeType = this.commonService.checkEnterpriseType() ? 2 : 1;
  }
  isNotAttestedUser: boolean = false;

  procedure = {
    id: this.data.dataKey != undefined ? this.data.dataKey.id : null,
    procedureName: this.data.dataKey != undefined ? this.data.dataKey.procedureName : '',
    description: this.data.dataKey != undefined ? this.data.dataKey.description : '',
    type: this.data.dataKey != undefined ? this.data.dataKey.type : new Number(),
    enterpriseId: localStorage.getItem('enterpriseId'),
    userId: null,
    status: this.data.dataKey != undefined ? this.data.dataKey.status : 1,
  };

  // Template để tạo procedureDetail
  procedureDetail = {
    order: new Number(),
    type: new Number(),
    enterpriseId: localStorage.getItem('enterpriseId'),
    customerId: new Number(),
    isCreatedSide: new Number(),
    userId: localStorage.getItem('userId'),
    role: new Number(),
    isSignNoLogin: new Number(),
    email: '',
    phone: ''
  };

  procedureDto = {
    procedure: this.procedure,
    procedureDetail: [],
  };
  format = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;

  isMultiCreateProcedure = false;
  procedureNamePrefix = '';
  isFormChanging = false;
  change = false;
  checkEscKey = false;
  urlApi = '/procedure/create';
  serviceTypesFilterCtrl: FormControl = new FormControl();
  serviceTypes: comboBox[] = [];
  private _onDestroy = new Subject<void>();
  formChangesSubscription: Subscription;
  valueSelect = null;
  firstEditLoaded = true;
  document: DocumentEntity;
  public onChangePanelData = new Subject();
  customer: DocumentCustomerEntity;
  isChangeParentDocument = false;
  RECORD_PARTY_SIGN: EnterpriseEntity[] = [];
  RECORD_PARTY_SIGN_TO_BACK_DATA:  any[] = [];
  isValidExistingSigning = false;
  subscriptions: Subscription = new Subscription();
  private subscribeIsInvalidSetPartyFlow: BehaviorSubject<boolean>;
  private subscribeIsValidNoUserExist: BehaviorSubject<boolean>;
  private subscribeIsNotAttestedInvalidSetCreatedSideParty: BehaviorSubject<boolean>;
  filteredPartyOptions = [];
  timeOutQueryServer = null;
  inputPartyValue: string;
  nzCheckLoadingParty = false;
  private customerDialog: MatDialogRef<AddCustomerDialogComponent>;
  enumContractEnterpriseStatus = EnumContractEnterpriseStatus;
  inputUserValue: string;
  nzCheckLoadingUser = false;
  nzCheckLoadingUserSign = false;
  isFullProcedure = this.data.dataKey != undefined ? (this.data.dataKey.type == 1 ? true : false) : null;

  @ViewChildren('focusInput') focusInput;
  @ViewChild('f', {static: false}) ngForm: NgForm;
  @ViewChild('procedureNameRef', {static: false})
  @ViewChild('procedureTypeRef', {static: false}) procedureTypeRef: MatSelect;
  procedureNameRef: ElementRef;
  procedureNameRef$: Observable<any>;
  procedureNameRefSubscription: Subscription;
  showTableMembers = true;
  valueAddPartyOrder = 2;
  valueCopyPartyOrder = 1;
  RECORD_USER_PERFORM_SIGN: UserEntity[] = [];
  isValidNoUserExist = false;
  enterpriseIdInDocument = '';
  @ViewChildren(MatExpansionPanel) panels: QueryList<MatExpansionPanel>;
  isInvalidSetPartyFlow = false;
  isInvalidSetCreatedSideParty = false;
  public onChangeTemplate = new Subject();
  templateDocument: any;
  @Output() hasChange: EventEmitter<boolean> = new EventEmitter();
  filteredUserOptions = [];
  roleUser = EnumContractUserRole;
  @ViewChild('contentEmptyTable', {static: false})
  contentEmptyTable: TemplateRef<any>; // Set no display No_data on Nz-Table
  ENTERPRISE_DATA: EnterpriseEntity[] = [];
  isShowStreamSigningApproval = true;
  enterpriseIdParent: EnterpriseEntity[] = [];
  defaultEnterprises: EnterpriseEntity;
  isValidEnterpriseForm = false;
  /**
   * Index check form dirty
   */
  indexFormDirty = 0;
  flagCopy = false;
  isInvalidPartyOrder = false;
  dataSourceEnterprise = new MatTableDataSource();
  dataSourceUser = new MatTableDataSource();
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  selectedTypeDefault: any;
  isShowUserSignTable = true;
  indexUserSign = -1;
  inputUserSignValue: string;
  isUserSign;
  approverNumber: any;
  isCheckApprover = false;
  scopeType:number;
  isEmailInvalid = false;
  isPhoneInvalid = false;

  treeFormControl: FormControl = new FormControl('');
  valueSearchTreeOld: string = '';
  isSearchDataEmpty: boolean = false;
  defaultCheckedKeys: any[] = [];
  dataTreeSelected: any[] = [];
  defaultExpandedKeys: any[] = [];
  dataVirtualCheckedKeys: any[] = [];
  listDataTreeSelected: any[] = [];
  groupUserId: string = '';
  infoNodeBetweenUser = {
    id: '',
    type: ''
  }
  tempDataToTree: any[];
  featuresTree: any[] = [];
  enterpriseType: string = '';


  @HostListener('submit')
  onFormSubmit() {
    const invalidElements = this.el.nativeElement.querySelectorAll('.mat-form-field-invalid .mat-input-element,.mat-select-invalid');
    if (invalidElements.length > 0) {
      invalidElements[0].focus();
    }
  }

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(
    event: KeyboardEvent
  ) {
    if (!this.checkEscKey) {
      this.onNoClick();
    }
  }

  ngOnInit() {
    // this.apiService.addUrlToHandlingErrorRestApis(this.urlApi);
    this.approverNumber = this.data.approverNumber ? this.data.approverNumber : 0;
    this.procedure.procedureName = this.data.dataKey != undefined ? this.data.dataKey.procedureName : this.procedureNamePrefix;
    if(this.data && this.data.dataKey) {
      this.initPassedData();
      this.setFormChanging(false);
      this.getDataTree();
    }
    this.subscribeData();
    this.dataSourceEnterprise.sort = this.sort;
    this.dataSourceUser.sort = this.sort;
    if(!(this.data && this.data.dataKey)) {
      this.getDefaultEnterprises();
    } else {
      this.getDefaultEnterprises(false);
    }
    this.createContractService.recordsPartySign.next([]);
    this.createContractService.recordsUserPerformSign.next([]);
  }

  initPassedData() {
    this.createContractService.recordsPartySign.next([]);
    this.createContractService.recordsUserPerformSign.next([]);
    this.proService.searchProcedureDetails({
      id: this.data.dataKey.id,
      name: this.data.dataKey.procedureName,
      status: [this.data.dataKey.status],
      type: [this.data.dataKey.type],
      enterpriseId: localStorage.getItem('enterpriseId'),
      page: 0,
      pageSize: 999999999,
    }).subscribe(response => {
      let data = response.data;
      if(data.enterpriseSign.length) {
        data.enterpriseSign.sort((a, b) => {
          // If a's 'isActive' is true and b's 'isActive' is false, a comes before b
          if (a.isCreatedSide && !b.isCreatedSide) {
            return -1;
          }
          // If a's 'isActive' is false and b's 'isActive' is true, b comes before a
          else if (!a.isCreatedSide && b.isCreatedSide) {
            return 1;
          }
          // If both have the same 'isActive' value or both are true or false, maintain their original order
          else {
            return 0;
          }
        }).forEach(el => {
          if (!this.checkExistedParty(el.enterpriseId, el.customerId)) {
            this.RECORD_PARTY_SIGN = [
              ...this.RECORD_PARTY_SIGN,
              {
                enterpriseId: el.enterpriseId ? el.enterpriseId : this.commonService.generateUUID(),
                order: el.order != null ? el.order : this.valueCopyPartyOrder,
                email: el.email,
                enterpriseName: '',
                phone: el.phone,
                status: this.enumContractEnterpriseStatus.NO_PROCESS,
                isCreatedSide: el.isCreatedSide,
                customerId: el.customerId,
                name: el.name,
                certificateNo: el.taxCode ? el.taxCode : el.certificateNo,
                useDataForTemplate: false,
                isSignNoLogin: el.isSignNoLogin,
                customerType : el.customerType,
                signConfig: el.signConfig ? ( JSON.parse(el.signConfig).showImage? JSON.parse(el.signConfig).showImage : false ) : false
              },
            ];
            this.showTableMembers = this.checkExistedCreatorParty();
            // this.validateSetupParty();
            if (el.isCreatedSide) {
              // cập nhật enterpriseSignId nếu chủ thể bên lập thay đổi
              this.enterpriseIdInDocument = el.enterpriseId;
              this.updateEnterpriseIdofUserList();
            }

            if(this.RECORD_USER_PERFORM_SIGN.length > 0)
              this.setFormChanging(true);
            this.inputPartyValue = '';
            this.filteredPartyOptions = [];
            this.valueCopyPartyOrder =
              Math.max.apply(
                Math,
                this.RECORD_PARTY_SIGN.map((o) => {
                  return o.order;
                })
              ) + 1;
            this.createContractService.recordsPartySign.next(
              this.RECORD_PARTY_SIGN
            );
          }
        })
        this.validateSetupParty();
      } else {
        this.getDefaultEnterprises();
      }
      data.userSign.forEach(el => {
        if (!this.checkExistedUser(el.id, el.name, el.email)) {
          // Re-set all old members to "APPROVE" role
          let RECORD_USER_PERFORM_SIGN = this.RECORD_USER_PERFORM_SIGN;

            RECORD_USER_PERFORM_SIGN = [
              ...RECORD_USER_PERFORM_SIGN,
              {
                order: el.order,
                userId: el.userId,
                enterpriseSignId: this.enterpriseIdInDocument,
                name: el.name,
                email: el.email,
                role: el.role + '',
                phone: el.phone,
                isSignDigitalCertificate: el.isSignDigitalCertificate ? el.isSignDigitalCertificate : false,
                isCreatedSide: true,
                signConfig: el.signConfig ? this.setDataSignConfig(JSON.parse(el.signConfig)) : { resize: false, showImage: el.isSignDigitalCertificate ? true : (el.role + '' == '1' ? true : false) },
                userPosition: el.userPosition
            },
          ];
          this.createContractService.recordsUserPerformSign.next(
            RECORD_USER_PERFORM_SIGN
          );
          this.createContractService.isDirty = true;
          this.inputUserValue = '';
          this.isValidNoUserExist = false;
          this.subscribeIsValidNoUserExist.next(false);

          // this.valueSelectedUserRole = (this.roleUser.APPROVE + '');
          // this.validateErrorSetUser();
          if(this.procedure.type == 1) {
              this.setFormChanging(true);
          } else if(this.procedure.type == 2) {
            this.setFormChanging(true);
          }
        }
      })
      if(data.procedureDataPermission && data.procedureDataPermission.length) {
        const enterpriseType = localStorage.getItem('isParent') == 'true' ? 'COMPANY' : 'BRANCH';
        this.listDataTreeSelected = [...data.procedureDataPermission.map((data) => ({
          ...data,
          id: data.dataId,
          type: data.dataType ? data.dataType : '',
          key: data.dataId + (data.dataType ? data.dataType : '') + ((data.dataType === 'NODE_BETWEEN_BRANCH' || data.dataType === 'NODE_BETWEEN_USER') ? localStorage.getItem('enterpriseId') : (data.parentId ? data.parentId : '')),
          parentType: (data.dataType === 'NODE_BETWEEN_BRANCH' || data.dataType === 'NODE_BETWEEN_USER') ? enterpriseType : (data.parentType ? data.parentType : null),
          parentId: (data.dataType === 'NODE_BETWEEN_BRANCH' || data.dataType === 'NODE_BETWEEN_USER') ? localStorage.getItem('enterpriseId') : (data.parentId ? data.parentId : null)
        }))];

        this.dataTreeSelected = [...this.listDataTreeSelected.map((node) => ({
          id: null,
          groupUserId: this.groupUserId,
          dataId: node.id,
          parentId: node.parentId ? node.parentId : null,
          dataType: node.type,
          parentType: node.parentType ? node.parentType : null
        }))];
        this.defaultCheckedKeys = [...data.procedureDataPermission.map((item) => item.dataId + item.dataType + ((item.dataType === 'NODE_BETWEEN_BRANCH' || item.dataType === 'NODE_BETWEEN_USER') ? localStorage.getItem('enterpriseId') : (item.parentId ? item.parentId : '')))];
      }
      this.setFormChanging(true);
      this.getDataTree();
    });
  }

  onProcedureTypeChange(isFullProcedure: boolean, showTableMembers: boolean) {
    this.isFullProcedure = isFullProcedure;
    this.showTableMembers = showTableMembers;
    if(isFullProcedure) {
      this.RECORD_PARTY_SIGN = this.RECORD_PARTY_SIGN.filter(e => !e.isChangeType);
      if(!this.checkExistedCreatorParty()) {
        this.showTableMembers = false;
      } else {
        this.showTableMembers = true;
      }
    } else {
      const itemPartySign = this.RECORD_PARTY_SIGN.find(e => !e.customerId || e.customerId.length == 0);
      if (!itemPartySign) {
        let dataBasePartySign = JSON.parse(JSON.stringify(this.RECORD_PARTY_SIGN_TO_BACK_DATA));
        this.RECORD_PARTY_SIGN = [
          ...dataBasePartySign,
          ...this.RECORD_PARTY_SIGN
        ];
        this.RECORD_PARTY_SIGN  =  this.RECORD_PARTY_SIGN.map((item, index) => { item.order = index + 1; return item });
        this.RECORD_PARTY_SIGN[0].isChangeType = true;
        this.showTableMembers = this.checkExistedCreatorParty();
        this.valueAddPartyOrder =
        Math.max.apply(
          Math,
          this.RECORD_PARTY_SIGN.map((o) => {
            return o.order;
          })
        ) + 1;
      }
    }
  }

  checkFormChanging() {
    if(this.procedure.type == 1) {
      if(this.RECORD_PARTY_SIGN.length > 0)
        this.setFormChanging(true);
      else
        this.setFormChanging(false);
    } else if(this.procedure.type == 2) {
      this.setFormChanging(true);
    }
  }

  ngAfterViewInit() {
    // this.procedureNameRef$ = fromEvent(
    //   this.procedureNameRef.nativeElement,
    //   'input'
    // );
    // this.procedureNameRefSubscription = this.procedureNameRef$.subscribe((e) =>
    //   this.onProcedureNameChange(e)
    // );

    setTimeout((_) => this.focusInput.first.nativeElement.focus());
    this.nzConfigService.set('empty', {
      nzDefaultEmptyContent: this.contentEmptyTable,
    });
    this.formChangesSubscription = this.ngForm.form.statusChanges.subscribe(
      () => {
        // if(this.RECORD_USER_PERFORM_SIGN.length <= 0) {
        //   this.isFormChanging = false;
        // }
      }
    );

    setTimeout((_) => (this.firstEditLoaded = false), 100);

  }

  changeProcedureType() {
    if(this.isFullProcedure==true) {
      this.getDefaultEnterprises();
    }
  }

  /**
   * Implement ngOnDestroy method, unsubscribe error service to avoid memory leak
   */
  ngOnDestroy() {
    this.formChangesSubscription.unsubscribe();
    if (this.procedureNameRefSubscription) {
      this.procedureNameRefSubscription.unsubscribe();
    }
    this.apiService.removeUrlToHandlingErrorRestApis();
    this.upSubscribeData()
    this.procedureDto.procedureDetail = [];
    this.createContractService.recordsPartySign.next([]);
    this.createContractService.recordsUserPerformSign.next([]);
    this.RECORD_PARTY_SIGN = [];
    this.RECORD_USER_PERFORM_SIGN = [];
  }

  // Xóa chu the trong bảng Enterprise
  onClickDeleteElementRecordEnterprise(dataRow: any) {
    // this.setFormChanging(true);
    if (dataRow !== null && dataRow !== undefined) {
      const index: number = this.ENTERPRISE_DATA.indexOf(dataRow);
      if (index !== -1) {
        this.ENTERPRISE_DATA.splice(index, 1);
      }

      this.ENTERPRISE_DATA = this.ENTERPRISE_DATA.map((item, idx) => {
        return {
          ...item,
          order: idx + 1,
        };
      });
      this.dataSourceEnterprise = new MatTableDataSource(this.ENTERPRISE_DATA);
      this.validateFormEnterprise();
      this.checkIsSameEntepriseCurrentLogin();
      setTimeout(() => {
        if ((this.isInvalidSetPartyFlow || this.isEmailInvalid && this.scopeType == 1 || this.isPhoneInvalid) && this.RECORD_PARTY_SIGN.length == 0) {
          document.getElementById('inputParty').focus();
        } else {
          if(this.RECORD_USER_PERFORM_SIGN.length == 0)
            document.getElementById('inputUser').focus();
        }
      }, 500);
    }
  }

  // Check nó có pải được set luồng Ký/Duyệt hay ko?
  private checkIsSameEntepriseCurrentLogin() {
    if (this.ENTERPRISE_DATA !== null && this.ENTERPRISE_DATA.length !== undefined) {
      if (this.ENTERPRISE_DATA.filter(x => x.enterpriseId === this.defaultEnterprises.enterpriseId).length > 0) {
        this.isShowStreamSigningApproval = true;
        this.enterpriseIdParent = this.ENTERPRISE_DATA.filter(x => x.isCreatedSide === true);
      } else {
        this.isShowStreamSigningApproval = false;
      }
    } else {
      this.isShowStreamSigningApproval = false;
    }
  }

  // validate form Enterprise.
  private validateFormEnterprise() {
    if (this.ENTERPRISE_DATA.length === 0) {
      this.isValidEnterpriseForm = true;
    } else {
      this.isValidEnterpriseForm = false;
    }
  }

  subscribeData() {
    this.subscriptions.add(
      this.subscribeIsInvalidSetPartyFlow.asObservable().subscribe((res) => {
        if (res) {
          this.createContractService.isInvalidInfo.next(true);
          this.toastr.error(
            this.message.getMessage('validation.error_enterprise_no_set_up')
          );
        }
      })
    );

    this.subscriptions.add(
      this.subscribeIsNotAttestedInvalidSetCreatedSideParty.asObservable().subscribe(res => {
        if (res) {
          this.createContractService.isInvalidInfo.next(true);
          this.toastr.error(this.message.getMessage('validation.error_procedure_not_attested_no_setup_created_side'));
        }
      })
    );

    this.subscriptions.add(
      this.subscribeIsValidNoUserExist.asObservable().subscribe((res) => {
        if (res) {
          this.createContractService.isInvalidInfo.next(true);
          this.setFormChanging(false);
          this.toastr.error(
            this.message.getMessage('validation.error_user_no_set_up')
          );
        }
      })
    );
    this.subscriptions.add(
      this.createContractService.recordsPartySign
        .asObservable()
        .subscribe((res) => {
          if (res.length) {
            this.RECORD_PARTY_SIGN = res;
            const isCreatedSide = res.find((item) => item.isCreatedSide);
            if (!isCreatedSide) {
              this.showTableMembers = false;
            }
            this.valueAddPartyOrder =
              Math.max.apply(
                Math,
                this.RECORD_PARTY_SIGN.map((o) => {
                  return o.order;
                })
              ) + 1;
          } else if (this.createContractService.cacheRecordParty) {
            this.showTableMembers = false;
            this.valueAddPartyOrder = 1;
          }
        })
    );

    this.subscriptions.add(
      this.createContractService.recordsUserPerformSign
        .asObservable()
        .subscribe((res) => {
          if (res) {
            this.RECORD_USER_PERFORM_SIGN = res.sort((a, b) => {
              return a.order - b.order || a.userId.localeCompare(b.userId);
            });
            const checkUserSign = this.RECORD_USER_PERFORM_SIGN.filter(item => item.role === '1');
            if (checkUserSign.length > 0) {
              this.isUserSign = true;
              this.indexUserSign = this.RECORD_USER_PERFORM_SIGN.indexOf(checkUserSign[0])
            } else {
              this.isUserSign = false;
              this.indexUserSign = -1;
            }

            const checkApprover = this.RECORD_USER_PERFORM_SIGN.filter(item => item.role === '2');
            if (checkApprover.length === Number(this.approverNumber) || checkApprover.length > Number(this.approverNumber)) {
              this.isCheckApprover = true;
            } else {
              this.isCheckApprover = false;
            }
          }
        })
    );

    // this.createContractService.currentStep.asObservable().subscribe(res => {
    //   if (res) {
    //     this.currentStep = res;
    //     if (res === 1) {
    //       this.onSubmit();
    //     }
    //   }
    // });
    this.subscriptions.add(
      this.createContractService.isGeneralInfoValid
        .asObservable()
        .subscribe((rs) => {
          if (rs) {
            this.onSubmit();
          }
        })
    );

    // this.subscriptions.add(
    //   this.createContractService.isBack.asObservable().subscribe((rs) => {
    //     if (rs) {
    //       this.createContractService.recordsPartySign.next(
    //         this.RECORD_PARTY_SIGN
    //       );
    //       this.createContractService.recordsUserPerformSign.next(
    //         this.RECORD_PARTY_SIGN.length ? this.RECORD_USER_PERFORM_SIGN : []
    //       );
    //       this.createContractService.isBack.next(false);
    //     }
    //   })
    // );

    this.subscriptions.add(
      this.createContractService.document.asObservable().subscribe((res) => {
        if (res) {
          this.document = res;
          if (
            this.document &&
            this.document.id &&
            this.createContractService.currentStep.getValue() === 0 &&
            !this.createContractService.recordsPartySign.getValue().length &&
            !this.createContractService.recordsUserPerformSign.getValue().length
          ) {
            this.initDataUpdate(this.document);
          }
        }
      })
    );

    this.notificationService.subscribeErrorService();

  }

  upSubscribeData(){
    this.createContractService.recordsPartySign.next([]);
    this.createContractService.recordsUserPerformSign.next([]);
    this.notificationService.unsubscribeErrorService();
  }

  onChangeUserRole(): void {
    this.validateErrorSetUser();
  }

  onChangeEnterpriseValue(key: string, data) {
    data[key] = data[key] ? data[key].trim() : '';
    const { enterpriseId, customerId } = data;
    if (this.scopeType == 1) {
      this.RECORD_PARTY_SIGN = this.RECORD_PARTY_SIGN.map(item => {
        if (item.enterpriseId === enterpriseId) {
          return data;
        } else {
          return item;
        }
      });
    } else {
      this.RECORD_PARTY_SIGN = this.RECORD_PARTY_SIGN.map(item => {
        if (enterpriseId && item.enterpriseId === enterpriseId || customerId && item.customerId === customerId) {
          return data;
        } else {
          return item;
        }
      });
    }
  }

  get isFromSSO(){
    if(localStorage.getItem('isFromSSO') =='true'){
      return true
    }
    return false
   }

  public openAddCustomer() {
    this.customerDialog = this.dialog.open(AddCustomerDialogComponent, {
      width: '70%',
      data: true,
    });

    this.customerDialog.componentInstance.createSuccess
      .asObservable()
      .subscribe(() => {
        this.getCustomerById(
          this.documentService.getCustomerId(),
          false,
          (customer) => {
            this.RECORD_PARTY_SIGN = [
              ...this.RECORD_PARTY_SIGN,
              {
                enterpriseId: customer.customerId,
                order: this.valueAddPartyOrder,
                email: customer.customerEmail,
                enterpriseName: '',
                phone: customer.customerPhone,
                status: this.enumContractEnterpriseStatus.NO_PROCESS,
                isCreatedSide: false,
                customerId: this.documentService.getCustomerId(),
                name: customer.customerName,
                certificateNo:
                  customer.customerTaxCode.length > 0
                    ? customer.customerTaxCode
                    : customer.customerCertificateNo,
                useDataForTemplate: false,
                isSignNoLogin: false,
                customerType : customer.customerType
              },
            ];
            this.valueAddPartyOrder =
              Math.max.apply(
                Math,
                this.RECORD_PARTY_SIGN.map((o) => {
                  return o.order;
                })
              ) + 1;

            this.createContractService.isDirty = true;
            // this.createContractService.recordsPartySign.next(RECORD_PARTY_SIGN);
          }
        );
      });
  }

  getDefaultEnterprises(isGetBackData: boolean = true) {
    // => push element first to array nếu nó không phải đang edit
    this.enterpriseIdInDocument = localStorage.getItem('enterpriseId');
      this.enterpriseService
        .getEnterpriseByID(this.enterpriseIdInDocument)
        .subscribe(
          (rs) => {
            if (rs && rs.data && !this.RECORD_PARTY_SIGN.length && isGetBackData) {
              this.RECORD_PARTY_SIGN = [
                {
                  enterpriseId: rs.data.id || '',
                  order: 1,
                  email: rs.data.email || '',
                  enterpriseName: '',
                  phone: rs.data.phone || '',
                  status: this.enumContractEnterpriseStatus.NO_PROCESS,
                  isCreatedSide: true,
                  customerId: '',
                  name: rs.data.name || '',
                  certificateNo:
                    rs.data.taxCode && rs.data.taxCode.length > 0
                      ? rs.data.taxCode
                      : rs.data.certificateNo,
                  useDataForTemplate: false,
                  isSignNoLogin: rs.data.isSignNoLogin,
                },
              ];
              this.RECORD_PARTY_SIGN_TO_BACK_DATA = [
                {
                  enterpriseId: rs.data.id || '',
                  order: 1,
                  email: rs.data.email || '',
                  enterpriseName: '',
                  phone: rs.data.phone || '',
                  status: this.enumContractEnterpriseStatus.NO_PROCESS,
                  isCreatedSide: true,
                  customerId: '',
                  name: rs.data.name || '',
                  certificateNo:
                    rs.data.taxCode && rs.data.taxCode.length > 0
                      ? rs.data.taxCode
                      : rs.data.certificateNo,
                  useDataForTemplate: false,
                  isSignNoLogin: rs.data.isSignNoLogin,
                },
              ];
              // this.createContractService.recordsPartySign.next(RECORD_PARTY_SIGN);
            }

            if (!isGetBackData) {
              this.RECORD_PARTY_SIGN_TO_BACK_DATA = [
                {
                  enterpriseId: rs.data.id || '',
                  order: 1,
                  email: rs.data.email || '',
                  enterpriseName: '',
                  phone: rs.data.phone || '',
                  status: this.enumContractEnterpriseStatus.NO_PROCESS,
                  isCreatedSide: true,
                  customerId: '',
                  name: rs.data.name || '',
                  certificateNo:
                    rs.data.taxCode && rs.data.taxCode.length > 0
                      ? rs.data.taxCode
                      : rs.data.certificateNo,
                  useDataForTemplate: false,
                  isSignNoLogin: rs.data.isSignNoLogin,
                },
              ];
            }
          },
          (error) => console.log(error)
        );
  }

  autocompletePartySelected($event: any, model: any) {
    if ($event.isUserInput) {
      if (!this.checkExistedParty(model.enterpriseId, model.customerId)) {
        this.RECORD_PARTY_SIGN = [
          ...this.RECORD_PARTY_SIGN,
          {
            enterpriseId: model.enterpriseId,
            order: this.valueAddPartyOrder,
            email: model.email,
            enterpriseName: '',
            phone: model.phone,
            status: this.enumContractEnterpriseStatus.NO_PROCESS,
            isCreatedSide: model.isCreatedSide,
            customerId: model.customerId,
            name: model.name,
            certificateNo: model.taxCode ? model.taxCode : model.certificateNo,
            useDataForTemplate: false,
            isSignNoLogin: false,
            customerType : model.customerType
          },
        ];

        this.showTableMembers = this.checkExistedCreatorParty();
        this.validateSetupParty();
        if (model.isCreatedSide) {
          // cập nhật enterpriseSignId nếu chủ thể bên lập thay đổi
          this.enterpriseIdInDocument = model.enterpriseId;
          this.updateEnterpriseIdofUserList();
        }

        if(this.procedure.type == 1) {
          if(this.showTableMembers) {
            const userSign = this.RECORD_USER_PERFORM_SIGN.find(user => user.role == '1');
            if (this.RECORD_USER_PERFORM_SIGN.length > 0 && userSign)
              this.setFormChanging(true);
            else
              this.setFormChanging(false);
          } else {
            if(this.RECORD_PARTY_SIGN.length > 0)
              this.setFormChanging(true);
            else
              this.setFormChanging(false);
          }
        } else if(this.procedure.type == 2) {
          const userSign = this.RECORD_USER_PERFORM_SIGN.find(user => user.role == '1');
          if (userSign) {
            this.setFormChanging(true);
          } else {
            this.setFormChanging(false);
          }
        }
        this.inputPartyValue = '';
        this.filteredPartyOptions = [];
        this.valueAddPartyOrder =
          Math.max.apply(
            Math,
            this.RECORD_PARTY_SIGN.map((o) => {
              return o.order;
            })
          ) + 1;
        this.createContractService.recordsPartySign.next(
          this.RECORD_PARTY_SIGN
        );

      } else {
        this.toastr.error(
          this.commonService.format(
            this.message.getMessage('messages.add_party_apostrophe_duplicate'),
            model.name
          )
        );
      }
    }
  }

  // update sign-enterprise Id for all users in current list
  private updateEnterpriseIdofUserList() {
    if (this.RECORD_USER_PERFORM_SIGN.length > 0) {
      const RECORD_USER_PERFORM_SIGN = this.RECORD_USER_PERFORM_SIGN.map(
        (item) => {
          return {
            ...item,
            enterpriseSignId: this.enterpriseIdInDocument,
          };
        }
      );

      this.createContractService.recordsUserPerformSign.next(
        RECORD_USER_PERFORM_SIGN
      );
    }
  }

  /**
   * On submit form
   */
   onClickBtnSubmit() {
    this.sortOrderApproveSign();
    this.procedureDto.procedureDetail = [];
    if(this.RECORD_PARTY_SIGN[0])
    this.standardizedData();
      if(this.procedure.type == 1) {
      this.RECORD_USER_PERFORM_SIGN.forEach(el => {
        this.procedureDto.procedureDetail.push({
          order: el.order,
          type: 2,
          enterpriseId: el.enterpriseSignId,
          customerId: null,
          isCreatedSide: el.isCreatedSide,
          userId: el.userId,
          role: el.role,
          isSignNoLogin: null,
          isSignDigitalCertificate: el.isSignDigitalCertificate ? el.isSignDigitalCertificate : false,
          email: null,
          phone: null,
          signConfig: JSON.stringify(el.signConfig)
        });
      });

      this.RECORD_PARTY_SIGN.forEach(el => {
        if(el.isCreatedSide) {
          this.procedureDto.procedureDetail.push({
            order: el.order,
            type: 1,
            enterpriseId: el.enterpriseId,
            customerId: null,
            isCreatedSide: el.isCreatedSide,
            userId: null,
            role: null,
            isSignNoLogin: el.isSignNoLogin,
            email: null,
            phone: null
          });
        } else {
          this.procedureDto.procedureDetail.push({
            order: el.order,
            type: 1,
            enterpriseId: el.enterpriseId,
            customerId: el.customerId,
            isCreatedSide: el.isCreatedSide,
            userId: null,
            role: null,
            isSignNoLogin: el.isSignNoLogin,
            email: el.email,
            phone: el.phone,
            signConfig:el.signConfig? JSON.stringify({showImage:el.signConfig}) :  JSON.stringify({showImage:false})
          });
        }
      });
    } else if (this.procedure.type == 2) {
      this.RECORD_USER_PERFORM_SIGN.forEach(el => {
        this.procedureDto.procedureDetail.push({
          order: el.order,
          type: 2,
          enterpriseId: el.enterpriseSignId,
          customerId: null,
          isCreatedSide: el.isCreatedSide,
          userId: el.userId,
          role: el.role,
          isSignNoLogin: null,
          isSignDigitalCertificate: el.isSignDigitalCertificate ? el.isSignDigitalCertificate : false,
          email: null,
          phone: null,
          signConfig: JSON.stringify(el.signConfig)
        });
      });
    }

    this.procedureDto.procedureDetail = new Array(this.procedureDto.procedureDetail);
    this.onCreateProcedure();
  }

  onChangeOrderOfPartySign() {
    if(this.procedure.type == 1) {
      if(this.RECORD_PARTY_SIGN.length > 0)
        this.setFormChanging(true);
      else
        this.setFormChanging(false);
    } else if(this.procedure.type == 2) {
      this.setFormChanging(true);
    }
    this.valueAddPartyOrder =
      Math.max.apply(
        Math,
        this.RECORD_PARTY_SIGN.map((item) => {
          return item.order;
        })
      ) + 1;
  }

  onClickDeleteElementRecordParty(enterpriseId: any, customerId: string): void {
    if (enterpriseId.length > 0) {
      this.RECORD_PARTY_SIGN = this.RECORD_PARTY_SIGN.filter(
        (d) => d.enterpriseId !== enterpriseId
      );
    } else {
      this.RECORD_PARTY_SIGN = this.RECORD_PARTY_SIGN.filter(
        (d) => d.customerId !== customerId
      );
    }
    if (this.RECORD_PARTY_SIGN && this.RECORD_PARTY_SIGN.length > 0) {
      this.valueAddPartyOrder =
        Math.max.apply(
          Math,
          this.RECORD_PARTY_SIGN.map((o) => {
            return o.order;
          })
        ) + 1;
    } else {
      this.valueAddPartyOrder = 1;
    }
    this.showTableMembers = this.checkExistedCreatorParty();
    if(this.procedure.type == 1) {
      if(this.showTableMembers) {
        const userSign = this.RECORD_USER_PERFORM_SIGN.find(user => user.role == '1');
        if (this.RECORD_USER_PERFORM_SIGN.length > 0 && userSign)
          this.setFormChanging(true);
        else
          this.setFormChanging(false);
      } else {
        if(this.RECORD_PARTY_SIGN.length > 0)
          this.setFormChanging(true);
        else
          this.setFormChanging(false);
      }
    } else if(this.procedure.type == 2) {
      const userSign = this.RECORD_USER_PERFORM_SIGN.find(user => user.role == '1');
      if (userSign) {
        this.setFormChanging(true);
      } else {
        this.setFormChanging(false);
      }
    }

    this.validateSetupParty();
    this.createContractService.recordsPartySign.next(this.RECORD_PARTY_SIGN);
    setTimeout(() => {
      if ((this.isInvalidSetPartyFlow || this.isEmailInvalid && this.scopeType == 1 || this.isPhoneInvalid) && this.RECORD_PARTY_SIGN.length == 0) {
        document.getElementById('inputParty').focus();
      } else {
        if(this.RECORD_USER_PERFORM_SIGN.length == 0)
          document.getElementById('inputUser').focus();
      }
    }, 500);
  }

  onChangeUserSearch(event): void {
    if (this.inputUserValue.trim().length > 0) {
      this.nzCheckLoadingUser = true;
      this.autoUserService
        .fetchAuto(this.inputUserValue.trim())
        .then((result) => {
          this.filteredUserOptions = result;
        })
        .finally(() => {
          this.nzCheckLoadingUser = false;
        });
    } else {
      this.inputUserValue = '';
      this.filteredUserOptions = [];
    }
  }

  onChangeUserSignSearch(event): void {
    if (this.inputUserSignValue.trim().length > 0) {
      this.nzCheckLoadingUserSign = true;
      this.autoUserService
        .fetchAuto(this.inputUserSignValue.trim())
        .then((result) => {
          this.filteredUserOptions = result;
        })
        .finally(() => {
          this.nzCheckLoadingUserSign = false;
        });
    } else {
      this.inputUserSignValue = '';
      this.filteredUserOptions = [];
    }
  }

  initDataUpdate(document) {
    this.document = document;
    // if (serviceType) {
    //   this.document.serviceType = serviceType.id;
    // }
    this.getListEnterpriseUserSignBydocumentId();
  }

  // /**
  //  * Lấy danh sách Người dùng sẽ ký/Duyệt Hợp đồng && Lấy danh sách các bên chủ thể sẽ Ký Hợp đồng
  //  */
  getListEnterpriseUserSignForCopy() {
    if (this.document && this.document.id) {
      this.documentService
        .getListEnterpriseUserSignForCopy(this.document.id)
        .subscribe(
          (rs) => {
            if (rs.data) {
              this.getListEnterpriseWillSign(rs.data.enterpriseSign);
              this.getListUserWillSignContract(rs.data.userSign);
            }
          },
          (error) => console.log(error)
        );
    }
  }

  checkExistedParty(enterpriseId: string, customerId: string) {
    const existedList = this.RECORD_PARTY_SIGN.filter((e) => {
      return enterpriseId ? e.enterpriseId === enterpriseId : e.customerId === customerId
    });

    return existedList.length > 0;
  }

  checkExistedCreatorParty(): boolean {
    console.log('this.RECORD_PARTY_SIGN', this.RECORD_PARTY_SIGN);

    const existedList = this.RECORD_PARTY_SIGN.filter((e) => {
      return e.isCreatedSide === true;
    });

    return existedList.length > 0;
  }

  autocompleteUserSelected($event: any, model: any) {
    if ($event.isUserInput) {
      if (!this.checkExistedUser(model.id, model.name, model.email)) {
        // Re-set all old members to "APPROVE" role
        let RECORD_USER_PERFORM_SIGN = this.RECORD_USER_PERFORM_SIGN;

        RECORD_USER_PERFORM_SIGN = [
          ...RECORD_USER_PERFORM_SIGN,
          {
            order: RECORD_USER_PERFORM_SIGN.filter((data) => data.role == '2').length ? RECORD_USER_PERFORM_SIGN.filter((data) => data.role == '2')[RECORD_USER_PERFORM_SIGN.filter((data) => data.role == '2').length - 1].order + 1 : 1,
            userId: model.id,
            enterpriseSignId: this.enterpriseIdInDocument,
            name: model.name,
            email: model.email,
            role: this.roleUser.APPROVE + '',
            isSignDigitalCertificate: model.isSignDigitalCertificate ? model.isSignDigitalCertificate : false,
            phone: model.phone,
            isCreatedSide: true,
            signConfig: model.signConfig ? this.setDataSignConfig(JSON.parse(model.signConfig)) : { resize: false, showImage: model.isSignDigitalCertificate ? true : (this.roleUser.APPROVE + '' == '1' ? true : false) },
            userPosition: model.userPosition
          },
        ];
        this.createContractService.recordsUserPerformSign.next(
          RECORD_USER_PERFORM_SIGN
        );
        this.createContractService.isDirty = true;
        this.inputUserValue = '';

        // this.valueSelectedUserRole = (this.roleUser.APPROVE + '');
        // this.validateErrorSetUser();
        if (this.procedure.type == 1) {
          const userSign = this.RECORD_USER_PERFORM_SIGN.find(user => user.role == '1');
          if (this.RECORD_PARTY_SIGN.length > 0 && userSign)
            this.setFormChanging(true);
          else
            this.setFormChanging(false);
        } else if (this.procedure.type == 2) {
          const userSign = this.RECORD_USER_PERFORM_SIGN.find(user => user.role == '1');
          if (userSign) {
            this.setFormChanging(true);
          } else {
            this.setFormChanging(false);
          }
        }
      }
    }

  }

  autocompleteUserSignSelected($event: any, model: any) {
    if ($event.isUserInput) {
      if (!this.checkExistedUser(model.id, model.name, model.email)) {
        // Re-set all old members to "APPROVE" role
        let RECORD_USER_PERFORM_SIGN = this.RECORD_USER_PERFORM_SIGN;

        RECORD_USER_PERFORM_SIGN = [
          ...RECORD_USER_PERFORM_SIGN,
          {
            order: RECORD_USER_PERFORM_SIGN.length + 1,
            userId: model.id,
            enterpriseSignId: this.enterpriseIdInDocument,
            name: model.name,
            email: model.email,
            role: this.roleUser.SIGN + '',
            isSignDigitalCertificate: model.isSignDigitalCertificate ? model.isSignDigitalCertificate : false,
            phone: model.phone,
            isCreatedSide: true,
            signConfig: model.signConfig ? this.setDataSignConfig(JSON.parse(model.signConfig)) : { resize: false, showImage: model.isSignDigitalCertificate ? true : (this.roleUser.SIGN + '' == '1' ? true : false) },
            userPosition: model.userPosition
          },
        ];
        this.createContractService.recordsUserPerformSign.next(
          RECORD_USER_PERFORM_SIGN
        );
        this.createContractService.isDirty = true;
        this.inputUserSignValue = '';
        this.isValidNoUserExist = false;
        this.subscribeIsValidNoUserExist.next(false);

        // this.valueSelectedUserRole = (this.roleUser.APPROVE + '');
        // this.validateErrorSetUser();
        if (this.procedure.type == 1) {
          const userSign = this.RECORD_USER_PERFORM_SIGN.find(user => user.role == '1');
          if (this.RECORD_PARTY_SIGN.length > 0 && userSign)
            this.setFormChanging(true);
          else
            this.setFormChanging(false);
        } else if (this.procedure.type == 2) {
          const userSign = this.RECORD_USER_PERFORM_SIGN.find(user => user.role == '1');
          if (userSign) {
            this.setFormChanging(true);
          } else {
            this.setFormChanging(false);
          }
        }
      }
    }

  }

  checkExistedUser(id: string, fullname: string, email: string) {
    const existedList = this.RECORD_USER_PERFORM_SIGN.filter((e) => {
      return e.userId === id;
    });

    if (existedList.length > 0) {
        if (existedList[0].role === '1') {
          this.toastr.error(this.commonService.format(this.message.getMessage('messages.add_user_apostrophe_duplicate_sign'), [fullname + ' - ' + email]));
        } else {
          this.toastr.error(this.commonService.format(this.message.getMessage('messages.add_user_apostrophe_duplicate_approve'), [fullname + ' - ' + email]));
        }
      return true;
    } else {
      return false;
    }
  }
  changeChanKy(data){
    if(data.signConfig ){
      data.signConfig = true
    }
    else data.signConfig =data.signConfig = false;
  }
  onSelectCustomerForTemplate(id: any, value: boolean): void {
    if(this.procedure.type == 1) {
      if(this.RECORD_PARTY_SIGN.length > 0)
        this.setFormChanging(true);
      else
        this.setFormChanging(false);
    } else if(this.procedure.type == 2) {
      this.setFormChanging(true);
    }
    if (value) {
      // Nếu chọn 1 khách hàng để bind information into template
      if (id != null) {
        // Re-set những khách hàng khác là ko được chọn bind information into template
        this.RECORD_PARTY_SIGN = this.RECORD_PARTY_SIGN.map((item) => {
          return {
            ...item,
            useDataForTemplate: item.customerId === id,
          };
        });
        // this.createContractService.recordsPartySign.next(RECORD_PARTY_SIGN);

        // Bind customer data to template
        this.document.customerId = id;
        this.onChangeTemplate.next(this.templateDocument);
      }
    }
  }

  onChangePartySignSearch($event: any): void {
    this.filteredPartyOptions = [];
    if (
      $event.inputType.includes('insert') ||
      $event.inputType.includes('delete')
    ) {
      if (this.timeOutQueryServer) {
        clearTimeout(this.timeOutQueryServer);
      }
      this.timeOutQueryServer = setTimeout(() => {
        if (this.inputPartyValue.trim().length > 0) {
          this.nzCheckLoadingParty = true;
          this.autoEnterpriseService
            .fetchAuto(this.inputPartyValue.trim())
            .then((result) => {
              this.filteredPartyOptions = [];
              if (result) {
                for (const item of result) {
                  if (item.isCreatedSide) {
                    if (!this.checkExistedCreatorParty()) {
                      // Nếu đã có 1 đơn vị của bên Lập rồi thì ko cho thêm đơn vị khác của bên Lập nữa
                      // Chống lặp bản ghi trong danh sách suggest
                      const existedList = this.filteredPartyOptions.filter(
                        (e) => {
                          return e.enterpriseId === item.enterpriseId;
                        }
                      );
                      // if (existedList.length === 0) {
                        this.filteredPartyOptions.push(item);
                      // }
                    }
                  } else if (!this.checkExistedParty(item.enterpriseId, item.customerId)) {
                    // Nếu chưa được chọn thì cũng mới hiển thị cho chọn
                    // Chống lặp bản ghi trong danh sách suggest
                    const existedList = this.filteredPartyOptions.filter(
                      (e) => {
                        return e.enterpriseId === item.enterpriseId;
                      }
                    );
                    // if (existedList.length === 0) {
                      this.filteredPartyOptions.push(item);
                    // }
                  }
                }
              }
              // this.filteredPartyOptions = result;
            })
            .finally(() => {
              this.nzCheckLoadingParty = false;
            });
        } else {
          this.inputPartyValue = '';
        }
      }, 500);
    }
  }

  // Function handler set sự thay đổi trên form.
  setFormChanging(changingStatus: boolean): void {
    this.isFormChanging = changingStatus;
    this.hasChange.emit(changingStatus);
  }

  getListEnterpriseUserSignBydocumentId() {
    if (this.document && this.document.id) {
      this.documentService
        .getListEnterpriseUserSignBydocumentIdService(this.document.id)
        .subscribe(
          (rs) => {
            if (rs.data) {
              this.getListEnterpriseWillSign(rs.data.enterpriseSign);
              this.getListUserWillSignContract(rs.data.userSign);
            }
          },
          (error) => console.log(error)
        );
    }
  }

  // /**
  //  * Lấy danh sách Người dùng sẽ ký/Duyệt Hợp đồng
  //  */
  getListUserWillSignContract(data) {
    if (data) {
      this.RECORD_USER_PERFORM_SIGN = data.map((item) => ({
        ...item,
        order: item.order,
        userId: item.userId,
        enterpriseSignId: item.enterpriseSignId,
        name: item.userName,
        email: item.userEmail,
        role: item.role + '',
        phone: item.userPhone,
        isSignDigitalCertificate: item.isSignDigitalCertificate ? item.isSignDigitalCertificate : false,
        isCreatedSide: true,
        signConfig: item.signConfig ? this.setDataSignConfig(JSON.parse(item.signConfig)) : { resize: false, showImage: item.isSignDigitalCertificate ? true : (item.role + '' == '1' ? true : false) },
        userPosition: item.userPosition
      }));
      this.createContractService.recordsUserPerformSign.next(
        this.RECORD_USER_PERFORM_SIGN
      );
      // thiết lập enterpriseIdInDocument theo hợp đồng draft ban đầu
      if (this.RECORD_USER_PERFORM_SIGN.length > 0) {
        this.enterpriseIdInDocument =
          this.RECORD_USER_PERFORM_SIGN[0].enterpriseSignId;
        this.showTableMembers = true;
      } else {
        this.showTableMembers = false;
      }
    } else {
      console.log('ERROR function getListUserWillSignContract');
    }
  }

  getListEnterpriseWillSign(data) {
    if (data) {
      this.RECORD_PARTY_SIGN = data.map((item) => ({
        enterpriseId: item.enterpriseId,
        order: item.order,
        email: item.enterpriseEmail,
        enterpriseName: '',
        phone: item.enterprisePhone,
        status: item.status,
        isCreatedSide: item.customerId ? false : true, // CHÚ Ý ĐIỀU CHỈNH LẠI
        name: item.enterpriseName,
        certificateNo: item.enterpriseCertificateNo
          ? item.enterpriseCertificateNo
          : '',
        customerId: item.customerId,
        useDataForTemplate: item.useDataForTemplate,
        isSignNoLogin: item.isSignNoLogin,
      }));
      this.valueAddPartyOrder =
        Math.max.apply(
          Math,
          this.RECORD_PARTY_SIGN.map((o) => {
            return o.order;
          })
        ) + 1;

      this.createContractService.recordsPartySign.next(this.RECORD_PARTY_SIGN);
      this.createContractService.cacheRecordParty = JSON.parse(
        JSON.stringify(this.RECORD_PARTY_SIGN)
      );
      // this.ENTERPRISE_DATA = data.map(item => ({ ...item, phone: item.enterprisePhone, email: item.enterpriseEmail }));

      // //set value expanded when start.
      // for (var i: number = 0; i < this.ENTERPRISE_DATA.length; i++) {
      //   this.expanded[i] = false;
      // }

      // //new table enterprise.
      // this.dataSourceEnterprise = new MatTableDataSource(this.ENTERPRISE_DATA);
    } else {
      console.log('ERROR function getListEnterpriseWillSign');
    }
  }

  public onSubmit() {
    if (!this.validateErrorSetUser() && !this.validateSetupParty()) {
      if(this.RECORD_PARTY_SIGN[0])
        this.standardizedData();

      this.createContractService.recordsUserPerformSign.next(
        this.RECORD_USER_PERFORM_SIGN
      );
      this.createContractService.recordsPartySign.next(this.RECORD_PARTY_SIGN);
      this.createContractService.isRecordsPartySignValid.next(true);
    } else {
      // this.toastr.error(this.message.getMessage('messages.error_establish_party_or_user'));
      if (!this.panels) {
        this.createContractService.isRecordsPartySignValid.next(false);
        return;
      }
      this.createContractService.isInvalidInfo.next(true);
      this.panels.forEach((x, index) => {
        if (
          index === 2 &&
          (this.isInvalidSetPartyFlow || this.isEmailInvalid && this.scopeType == 1 || this.isPhoneInvalid || this.isInvalidSetCreatedSideParty)
        ) {
          x.open();
        }
        if (index === 3 && this.isValidNoUserExist) {
          x.open();
        }
      });

      setTimeout(() => {
        if (this.isInvalidSetPartyFlow || this.isEmailInvalid && this.scopeType == 1 || this.isPhoneInvalid || this.isInvalidSetCreatedSideParty) {
          document.getElementById('inputParty').focus();
        } else {
          document.getElementById('inputUser').focus();
        }
      }, 500);
      this.createContractService.isRecordsPartySignValid.next(false);
    }
  }

  private standardizedData() {
    // Reorder party list
    this.RECORD_PARTY_SIGN.sort((a, b) => a.order - b.order);
    let nextOrder = 1;
    let currentOrder = this.RECORD_PARTY_SIGN[0].order;
    this.RECORD_PARTY_SIGN[0].order = 1;
    this.RECORD_PARTY_SIGN.forEach((item) => {
      if (item.order > currentOrder) {
        nextOrder += 1;
        currentOrder = item.order;
      }
      item.order = nextOrder;
    });

    // // Nếu tạo hợp đồng upload thì ko sử dụng thông tin useDataForTemplate
    // if (this.valueSelect !== 0) {
    //   this.RECORD_PARTY_SIGN = this.RECORD_PARTY_SIGN.map((item) => {
    //     return {
    //       ...item,
    //       useDataForTemplate: false,
    //     };
    //   });
    // }

    // // Kiểm tra danh sách bên ký kết có bên Lập không
    // // Nếu ko có >> xóa trắng danh sách người dùng ký kết
    // const existedList = this.RECORD_PARTY_SIGN.filter((e) => {
    //   return e.isCreatedSide === true;
    // });

    // if (existedList.length <= 0) {
    //   this.createContractService.recordsUserPerformSign.next([]);
    //   // this.RECORD_USER_PERFORM_SIGN = [];
    // }
  }

  // validate form Enterprise.
  private validateSetupParty() {
    if(this.isFullProcedure) {
      let result = false;
      this.isInvalidSetPartyFlow = false;
      this.isInvalidSetCreatedSideParty = false;
      this.subscribeIsInvalidSetPartyFlow.next(this.isInvalidSetPartyFlow);
      console.log('this.isInvalidSetCreatedSideParty', this.isInvalidSetCreatedSideParty);

      this.subscribeIsNotAttestedInvalidSetCreatedSideParty.next(this.isInvalidSetCreatedSideParty);
      this.isEmailInvalid = false;
      this.isPhoneInvalid = false;

      if (this.RECORD_PARTY_SIGN.length === 0) {
        this.isInvalidSetPartyFlow = true;
        this.subscribeIsInvalidSetPartyFlow.next(this.isInvalidSetPartyFlow);
        result = true;
      } 
      // else {
      //   if (this.isNotAttestedUser) {
      //     // Quy trình ký đầy đủ cho hợp đồng không chứng thực bắt buộc phải có bên lập tham gia ký duyệt. Vui lòng thiết lập lại các bên tham gia.
      //     if (!this.checkExistedCreatorParty()) {
      //       this.isInvalidSetCreatedSideParty = true;
      //       this.subscribeIsNotAttestedInvalidSetCreatedSideParty.next(this.isInvalidSetCreatedSideParty);
      //       result = true;
      //     }
      //   }
      // }

      this.RECORD_PARTY_SIGN.sort((a, b) => a.order - b.order);
      this.RECORD_PARTY_SIGN.forEach((item, index) => {
        const regxPhone = new RegExp(this.phonePattern2);
        if (!regxPhone.test(item.phone)) {
          result = true;
          this.isPhoneInvalid = true;
        }
        if (item.email && item.email.length > 0) {
          const regxEmail = new RegExp(this.emailPattern);
          if (!regxEmail.test(item.email)) {
            result = true;
            this.isEmailInvalid = true;
          }
        } else {
          if (this.scopeType == 1) {
            const regxEmail = new RegExp(this.emailPattern);
            if (!regxEmail.test(item.email)) {
              result = true;
              this.isEmailInvalid = true;
            }
          }
        }
      });
      return result;
    }
  }

  onClickDeleteElementRecordUser(userId: any): void {
    let RECORD_USER_PERFORM_SIGN = this.RECORD_USER_PERFORM_SIGN.filter(
      (d) => d.userId !== userId
    );
    RECORD_USER_PERFORM_SIGN = RECORD_USER_PERFORM_SIGN.map((item, index) => ({
      ...item,
      order: index + 1,
    }));

    this.createContractService.recordsUserPerformSign.next(
      RECORD_USER_PERFORM_SIGN
    );
    if(this.procedure.type == 1) {
      const userSign = this.RECORD_USER_PERFORM_SIGN.find(user => user.role == '1');
      if (this.RECORD_PARTY_SIGN.length > 0 && this.RECORD_USER_PERFORM_SIGN.length > 0 && userSign)
        this.setFormChanging(true);
      else
        this.setFormChanging(false);
    } else if(this.procedure.type == 2) {
      const userSign = this.RECORD_USER_PERFORM_SIGN.find(user => user.role == '1');
      if (userSign) {
        this.setFormChanging(true);
      } else {
        this.setFormChanging(false);
      }
    }
    this.validateErrorSetUser();
    setTimeout(() => {
      if ((this.isInvalidSetPartyFlow || this.isEmailInvalid && this.scopeType == 1 || this.isPhoneInvalid) && this.RECORD_PARTY_SIGN.length == 0) {
        document.getElementById('inputParty').focus();
      } else {
        if(this.RECORD_USER_PERFORM_SIGN.length == 0)
          document.getElementById('inputUser').focus();
      }
    }, 500);
  }

  // validate form User
  private validateErrorSetUser(model?) {
    if(this.isFullProcedure == true) {
      // khi chủ thể không có chủ thể đang đăng nhập thì không kiểm tra user nữa
      const checkCurrentEnterprise = this.RECORD_PARTY_SIGN.filter(
        (item) => item.isCreatedSide === true
      );
      if (checkCurrentEnterprise.length === 0) {
        this.isValidNoUserExist = false;
        this.subscribeIsValidNoUserExist.next(false);
        return false;
      }

      // Kiểm tra trong list ko chua User nào?null
      if (this.RECORD_USER_PERFORM_SIGN.length === 0) {
        this.isValidNoUserExist = true;
        this.subscribeIsValidNoUserExist.next(true);
        return true;
      } else {
        this.isValidNoUserExist = false;
        this.subscribeIsValidNoUserExist.next(false);
      }
      return false;
    } else {
      // Kiểm tra trong list ko chua User nào?null
      if (this.RECORD_USER_PERFORM_SIGN.length === 0) {
        this.isValidNoUserExist = true;
        this.subscribeIsValidNoUserExist.next(true);
        return true;
      } else {
        this.isValidNoUserExist = false;
        this.subscribeIsValidNoUserExist.next(false);
      }
      return false;
    }
  }

  onProcedureNameChange(e) {
    const val: string = e.target.value;
    if (val.length <= 0) {
      this.procedure.procedureName = this.procedureNamePrefix;
    }
  }

  /**
   * Close adding branch dialog
   */
  onNoClick() {
    if (this.isFormChanging) {
      this.checkEscKey = true;
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: this.message.getMessage('messages.confirm_change_data'),
      });
      dialogRe.afterClosed().subscribe((rs) => {
        if (rs) {
          this.dialogRef.close();
        }
        dialogRe.close();
        this.checkEscKey = false;
      });
      this.subscriptions.unsubscribe();
    } else {
      this.dialogRef.close();
      this.subscriptions.unsubscribe();
    }
  }


  /**
   * Confirm before navigation
   */
  canDeactivate() {
    if (!this.isFormChanging) {
      return true;
    } else {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: this.message.getMessage('messages.confirm_change_data'),
      });
      return dialogRe.afterClosed().pipe(
        map((result) => {
          if (result) {
            return true;
          } else {
            return false;
          }
        }),
        first()
      );
    }
  }

  onCreateProcedure() {
    if(!this.validateErrorSetUser() && !this.validateSetupParty()){
      const data = {
        procedure: this.procedure,
        procedureDetail: this.procedureDto.procedureDetail[0],
        procedureDataPermission: this.dataTreeSelected
      };
      if(this.showTableMembers == false) {
        data.procedureDetail = data.procedureDetail.filter(
          el => el.userId == null
        )
      }
      this.proService.updateProcedure(data)
        .subscribe((res) => {
          if (res.success) {
            this.toastr.success(
              this.commonService.format(
                this.message.getMessage('messages.update_procedure_success')
              )
            );
            if (this.isMultiCreateProcedure) {
              setTimeout((_) => {
                this.focusInput.first.nativeElement.focus();
                this.procedure.procedureName = this.procedureNamePrefix;
              });
            } else {
              this.dialogRef.close();
            }
            this.subscriptions.unsubscribe();
          } else if(res.success == false) {
            this.procedureDuplicateHanlder(res);
          }
        }
      );
    } else {
      setTimeout(() => {
        if ((this.isInvalidSetPartyFlow || this.isEmailInvalid && this.scopeType == 1 || this.isPhoneInvalid) && this.RECORD_PARTY_SIGN.length == 0) {
          document.getElementById('inputParty').focus();
        } else {
          if(this.RECORD_USER_PERFORM_SIGN.length == 0)
            document.getElementById('inputUser').focus();
        }
      }, 500);
    }
  }

    /**
   * Check code document duplicate
   * @param rs data after request api
   */
     private procedureDuplicateHanlder(rs: any) {
      if (!rs.success) {
        if (String(rs.code) === '0x002701') {
          this.ngForm.form.controls.procedureName.setErrors({duplicate: true});
          document.getElementById('procedureName').focus();
        }
        if (String(rs.code) === '0x002802' || String(rs.code) === '0x002523') {
          this.toastr.error(rs.message);
        }
      }
    }

  private onAddProcedureError(rs: any) {
    if (!rs.success) {
      if (rs.code == '0x00707') {
        this.ngForm.form.controls.procedureName.setErrors({duplicate: true});
        document.getElementById('procedureName').focus();
      }
    }
  }

  public getCustomerById(id, isEdit = false, callback?: (customer) => void) {
    this.customerService.getCustomer(id).subscribe((rs) => {
      if (rs != null && rs.data != null) {
        const customer: DocumentCustomerEntity = {
          customerAccountNumber: rs.data.accountNumber
            ? rs.data.accountNumber
            : '',
          customerAddress: rs.data.address ? rs.data.address : '',
          customerAdminUser: rs.data.adminUser ? rs.data.adminUser : '',
          customerAttachments: rs.data.attachments ? rs.data.attachments : '',
          customerBankBranch: rs.data.bankBranch ? rs.data.bankBranch : '',
          customerBankName: rs.data.bankName ? rs.data.bankName : '',
          customerBank: `${rs.data.bankName ? rs.data.bankName + ', ' : ''}${
            rs.data.bankBranch ? rs.data.bankBranch : ''
          }`,
          customerBirthday: rs.data.birthday
            ? this.commonService.formatDate(new Date(rs.data.birthday))
            : null,
          customerCertificateId: rs.data.certificateId
            ? rs.data.certificateId
            : '',
          customerCertificateNo:
            rs.data.certificateNo && rs.data.customerType
              ? rs.data.certificateNo
              : '',
          customerCityId: rs.data.cityId ? rs.data.cityId : '',
          customerType: rs.data.customerType ? rs.data.customerType : '',
          customerDistrictId: rs.data.districtId ? rs.data.districtId : '',
          customerEmail: '',
          customerPhone: '',
          customerReceiverEmail: rs.data.email ? rs.data.email : '',
          customerEnterpriseId: rs.data.enterpriseId
            ? rs.data.enterpriseId
            : '',
          customerFax: rs.data.fax ? rs.data.fax : '',
          customerId: rs.data.customerId ? rs.data.customerId : '',
          customerIssuedAt: '',
          customerIssuedDate: '',
          customerIssuedDay: null,
          customerIssuedMonth: null,
          customerIssuedYear: null,
          customerName: rs.data.name ? rs.data.name : '',
          customerReceiverPhone: rs.data.phone ? rs.data.phone : '',
          customerPosition: rs.data.position ? rs.data.position : '',
          customerPrimaryEmail: rs.data.primaryEmail
            ? rs.data.primaryEmail
            : '',
          customerRepresentative: rs.data.representative
            ? this.commonService.capitalizeFirstLetter(rs.data.representative)
            : '',
          customerRepresentativeCertificateId: rs.data
            .representativeCertificateId
            ? rs.data.representativeCertificateId
            : '',
          customerRepresentativeCertificateNo: rs.data
            .representativeCertificateNo
            ? rs.data.representativeCertificateNo
            : '',
          customerRepresentativeIssuedAt: rs.data.representativeIssuedAt
            ? rs.data.representativeIssuedAt
            : '',
          customerRepresentativeIssuedDate: rs.data.representativeIssuedDate
            ? this.commonService.formatDate(
              new Date(rs.data.representativeIssuedDate)
            )
            : null,
          customerSex:
            typeof rs.data.sex !== 'undefined'
              ? rs.data.sex
              ? 'Nam'
              : 'Nữ'
              : '',
          customerTaxCode: rs.data.taxCode ? rs.data.taxCode : '',
          customerWardId: rs.data.wardId ? rs.data.wardId : '',
          customerAddressUsing: rs.data.address ? rs.data.address : '',
          customerContacter: rs.data.name
            ? this.commonService.capitalizeFirstLetter(rs.data.name)
            : '',

          customerIndividualOrRepresentativeCertificate:
            rs.data.customerType === 10000
              ? rs.data.certificateNo
              : rs.data.representativeCertificateNo,
          customerIndividualOrRepresentativeIssuedAt:
            rs.data.customerType === 10000
              ? rs.data.issuedAt
              : rs.data.representativeIssuedAt,
          customerIndividualOrRepresentativeIssuedDate:
            rs.data.customerType === 10000
              ? this.commonService.formatDate(new Date(rs.data.issuedDate))
              : this.commonService.formatDate(
              new Date(rs.data.representativeIssuedDate)
              ),
          customerIndividualOrRepresentativeIssuedDay: null,
          customerIndividualOrRepresentativeIssuedMonth: null,
          customerIndividualOrRepresentativeIssuedYear: null,
          customerIndividualOrRepresentativeIssuedShortYear: null,
          customerBusinessCertificateNo:
            rs.data.customerType !== 10000 ? rs.data.certificateNo : '',
          customerBusinessCertificateIssuedAt:
            rs.data.customerType !== 10000 ? rs.data.issuedAt : '',
          customerBusinessCertificateIssuedDate:
            rs.data.customerType !== 10000
              ? this.commonService.formatDate(new Date(rs.data.issuedDate))
              : '',
          customerBusinessCertificateIssuedDay: '',
          customerBusinessCertificateIssuedMonth: '',
          customerBusinessCertificateIssuedYear: '',
          customerTaxCode_01: '',
          customerTaxCode_02: '',
          customerTaxCode_03: '',
          customerTaxCode_04: '',
          customerTaxCode_05: '',
          customerTaxCode_06: '',
          customerTaxCode_07: '',
          customerTaxCode_08: '',
          customerTaxCode_09: '',
          customerTaxCode_10: '',
          customerTaxCode_11: '',
          customerTaxCode_12: '',
          customerTaxCode_13: '',
          customerTaxCode_14: '',
          customerContacterApartmantNumber: '',
          customerContacterStreetName: '',
          customerContacterGroup: '',
          customerContacterWard: '',
          customerContacterDistrict: '',
          customerContacterCity: '',
          customerContacterPhone: '',
          customerContacterEmail: '',
        };

        // Since system allow user editing customer, the customerEmail and the customerPhone
        //  could be different from the origin email and phone of customer
        if (this.firstEditLoaded) {
          customer.customerEmail = this.document.email;
          customer.customerPhone = this.document.phone;
        } else {
          customer.customerEmail = rs.data.email ? rs.data.email : '';
          customer.customerPhone = rs.data.phone ? rs.data.phone : '';
        }

        // If customer is enterprise
        if (customer.customerType !== 10000) {
          customer.customerIssuedAt = rs.data.issuedAt ? rs.data.issuedAt : '';
          customer.customerIssuedDate = rs.data.issuedDate
            ? this.commonService.formatDate(new Date(rs.data.issuedDate))
            : null;
          customer.customerIssuedDay = rs.data.issuedDate
            ? new Date(rs.data.issuedDate).getDate()
            : null;
          customer.customerIssuedMonth = rs.data.issuedDate
            ? new Date(rs.data.issuedDate).getMonth() + 1
            : null;
          customer.customerIssuedYear = rs.data.issuedDate
            ? new Date(rs.data.issuedDate).getFullYear().toString()
            : null;
        } else {
          customer.customerIssuedAt = '';
          customer.customerIssuedDate = '';
          customer.customerIssuedDay = null;
          customer.customerIssuedMonth = null;
          customer.customerIssuedYear = null;
        }
        // Generate splitted customerTaxCode
        for (let i = 0; i < 14; i++) {
          const key = `customerTaxCode_${i < 9 ? '0' + (i + 1) : i + 1}`;
          customer[key] = customer.customerTaxCode
            ? customer.customerTaxCode.charAt(i)
            : '';
        }

        if (
          customer.customerIndividualOrRepresentativeIssuedDate ||
          customer.customerIndividualOrRepresentativeIssuedDate !== ''
        ) {
          const customerIndividualOrRepresentativeIssuedDate =
            customer.customerIndividualOrRepresentativeIssuedDate.split('/');
          customer.customerIndividualOrRepresentativeIssuedDay =
            customerIndividualOrRepresentativeIssuedDate[0];
          customer.customerIndividualOrRepresentativeIssuedMonth =
            customerIndividualOrRepresentativeIssuedDate[1];
          customer.customerIndividualOrRepresentativeIssuedYear =
            customerIndividualOrRepresentativeIssuedDate[2];
          customer.customerIndividualOrRepresentativeIssuedShortYear =
            customerIndividualOrRepresentativeIssuedDate[2].slice(-2);
        }

        if (
          customer.customerBusinessCertificateIssuedDate ||
          customer.customerBusinessCertificateIssuedDate !== ''
        ) {
          const customerBusinessCertificateIssuedDate =
            customer.customerBusinessCertificateIssuedDate.split('/');
          customer.customerBusinessCertificateIssuedDay =
            customerBusinessCertificateIssuedDate[0];
          customer.customerBusinessCertificateIssuedMonth =
            customerBusinessCertificateIssuedDate[1];
          customer.customerBusinessCertificateIssuedYear =
            customerBusinessCertificateIssuedDate[2];
        } else {
          customer.customerBusinessCertificateIssuedDay = '';
          customer.customerBusinessCertificateIssuedMonth = '';
          customer.customerBusinessCertificateIssuedYear = '';
        }
        // In case of creating document by template, pass customer data to bind on template
        if (
          (this.document && this.document.typeId === 0) ||
          this.valueSelect === 0
        ) {
          this.onChangePanelData.next({
            customer: this.customer,
          });
        }

        if (callback) {
          callback(customer);
        }
        if (this.isChangeParentDocument === true) {
          this.isChangeParentDocument = false;
          return;
        }
      }
    });
  }

  setColspan(maximumSpan: number): number {
    if (this.valueSelect !== 0) maximumSpan -= 1;
    if (this.isNotAttestedUser && this.isFullProcedure) maximumSpan -= 1;

    return maximumSpan;
  }

  onChangeOrderApproveSign() {
    this.setFormChanging(true);
  }

  sortOrderApproveSign() {
    let newOrder = 0;
    let RECORD_USER_APPROVE = [...this.RECORD_USER_PERFORM_SIGN.filter(item => item.role === '2')];
    let RECORD_USER_SIGN = [...this.RECORD_USER_PERFORM_SIGN.filter(item => item.role === '1')];

    if(RECORD_USER_APPROVE.length) {
      RECORD_USER_APPROVE = RECORD_USER_APPROVE.sort((a, b) => {
        return a.order - b.order || a.userId.localeCompare(b.userId);
      });

      RECORD_USER_APPROVE = RECORD_USER_APPROVE.map((item, index) => {
        if(index === 0) {
          newOrder = 1;
          return {
            ...item,
            order: 1
          }
        } else {
          if(item.order !== RECORD_USER_APPROVE[index -1].order) {
            newOrder++;
          }
          return {
            ...item,
            order: newOrder
          }
        }
      });

      RECORD_USER_SIGN = RECORD_USER_SIGN.map((item) => ({
        ...item,
        order: RECORD_USER_APPROVE[RECORD_USER_APPROVE.length - 1].order + 1
      }))
    }

    const RECORD_USER_PERFORM_SIGN = RECORD_USER_APPROVE.concat(RECORD_USER_SIGN);

    this.RECORD_USER_PERFORM_SIGN = RECORD_USER_PERFORM_SIGN;
  }

  setDataSignConfig(signConfig: any) {
    let newDataSignConfig = { ...signConfig };
    if(newDataSignConfig.resize === null || newDataSignConfig.resize === undefined) {
      newDataSignConfig = { ...newDataSignConfig, resize: false };
    }
    if(newDataSignConfig.showImage === null || newDataSignConfig.showImage === undefined) {
      newDataSignConfig = { ...newDataSignConfig, showImage: true };
    }
    return newDataSignConfig;
  }

  checkDisplayBtnAddCustomer() {
    const permissions = localStorage.getItem('permissions') ? JSON.parse(localStorage.getItem('permissions')) : [];
    if(this.commonService.checkDefaultAdmin()) {
      return true;
    }
    if(permissions.includes(401)) {
      return true;
    }
    if(permissions.includes(4)) {
      return true;
    }
    return false;
  }

  comBack() {
    const dataComback = JSON.parse(JSON.stringify(this.RECORD_PARTY_SIGN_TO_BACK_DATA));
    this.RECORD_PARTY_SIGN = [
      ...dataComback,
      ...this.RECORD_PARTY_SIGN
    ]
    this.RECORD_PARTY_SIGN[0].order = this.valueAddPartyOrder;
    this.showTableMembers = this.checkExistedCreatorParty();
    this.valueAddPartyOrder =
    Math.max.apply(
      Math,
      this.RECORD_PARTY_SIGN.map((o) => {
        return o.order;
      })
    ) + 1;
    if (this.procedure.type == 1) {
      if (this.showTableMembers) {
        const userSign = this.RECORD_USER_PERFORM_SIGN.find(user => user.role == '1');
        if (this.RECORD_USER_PERFORM_SIGN.length > 0 && userSign)
          this.setFormChanging(true);
        else
          this.setFormChanging(false);
      } else {
        if (this.RECORD_PARTY_SIGN.length > 0)
          this.setFormChanging(true);
        else
          this.setFormChanging(false);
      }
    } else if (this.procedure.type == 2) {
      const userSign = this.RECORD_USER_PERFORM_SIGN.find(user => user.role == '1');
      if (userSign) {
        this.setFormChanging(true);
      } else {
        this.setFormChanging(false);
      }
    }
    this.validateSetupParty();
  }

  checkShowBtnAddEnterpriseEnt() {
    const itemPartySign = this.RECORD_PARTY_SIGN.find(e => !e.customerId || e.customerId.length == 0);
    if (itemPartySign) {
      return false;
    } 
    return true;
  }

  checkEnableButtonSave() {
    this.showTableMembers = this.checkExistedCreatorParty();
    if (this.procedure.type == 1) {
      if (this.showTableMembers) {
        const userSign = this.RECORD_USER_PERFORM_SIGN.find(user => user.role == '1');
        if (this.RECORD_USER_PERFORM_SIGN.length > 0 && userSign)
          return true;
        else
          return false;
      } else {
        if (this.RECORD_PARTY_SIGN.length > 0)
           return true;
        else
          return false;
      }
    } else if (this.procedure.type == 2) {
      const userSign = this.RECORD_USER_PERFORM_SIGN.find(user => user.role == '1');
      if (userSign) {
         return true;
      } else {
        return false;
      }
    }
  }

  searchTree() {
    if(this.treeFormControl.value !== this.valueSearchTreeOld) {
      if(!this.treeFormControl.value) {
        this.isSearchDataEmpty = false;
        this.getDataTree();
      } else {
        this.sv.searchTree(this.treeFormControl.value).subscribe((rs) => {
          if(rs && rs.data) {
            this.isSearchDataEmpty = false;
            this.patchDataTreeToArray(rs.data);
          } else {
            this.isSearchDataEmpty = true;
          }
        });
      }
      this.valueSearchTreeOld = this.treeFormControl.value;
      this.defaultCheckedKeys = [...this.defaultCheckedKeys];
    }
  }
  expandParentNode(event: NzFormatEmitEvent) {
    if((localStorage.getItem('isParent') == 'true' && event.node.origin.type === 'COMPANY') || (localStorage.getItem('isParent') == 'false' && event.node.origin.type === 'BRANCH')) {
      return;
    }
    setTimeout(() => {
      document.querySelectorAll('.hide-class').forEach((item) => {
        item.parentElement.parentElement.parentElement.classList.add('display-none');
      })
    }, 0);
    if (!this.treeFormControl.value) {
      if (event.node.isExpanded) {
        let dataTreeSelectedByParent = this.dataTreeSelected.filter((data) => data.parentId === event.node.origin.id);
        event.node.clearChildren();
        this.sv.getTreeNodes({ parentId: event.node.origin.id, parentType: event.node.origin.type }).pipe(
          map((rs) => rs.data.map((node) => ({
            title: node.name,
            id: node.id,
            level: 3,
            parentId: node.parentId,
            key: node.id + node.type + node.parentId,
            type: node.type,
            children: [],
            isActive: node.isActive,
            isLeaf: !node.isParent,
          })))
        ).subscribe((res) => {
          if(res && res.length) {
            event.node.addChildren(res);
            event.node.addChildren([
              {
                type: 'TYPE_VIRTUAL',
                id: 'nodeVirtualId' + (event.node.origin.id ? event.node.origin.id : ''),
                key: event.node.origin.id + 'TYPE_VIRTUAL' + event.node.origin.id,
                level: 3,
                parentId: event.node.origin.id,
                title: 'node virtual',
                children: [],
                isActive: true,
                isLeaf: true,
              }
            ]);

            dataTreeSelectedByParent.forEach((data) => {
              if(!res.filter((node) => data.dataId === node.id).length) {
                this.dataTreeSelected = [...this.dataTreeSelected.filter((dataSelected) => dataSelected.dataId !== data.dataId)];
                this.defaultCheckedKeys =[... this.defaultCheckedKeys.filter((keySelected) => keySelected !== data.dataId + data.dataType + data.parentId)];
              }
            });

            if (event.node.isChecked) {
              this.defaultCheckedKeys = [...this.defaultCheckedKeys, ...res.map((data) => data.key), event.node.origin.id + 'TYPE_VIRTUAL' + event.node.origin.id];
              this.defaultCheckedKeys = Array.from(new Set(this.defaultCheckedKeys));
            }
            this.defaultCheckedKeys = [...this.defaultCheckedKeys];
          } else {
            this.toastr.error(this.message.getMessage('user_group.message_data_changed'));
          }
        })
      }
    }
  }
  convertTreeToList(root: any) {
    const stack: any[] = [];
    const array: any[] = [];
    const hashMap = {};
    stack.push({
      ...root,
      level: 1,
      expand: true,
      key: root.id + root.type,
      title: root.name,
      type: root.type,
    });
    this.defaultExpandedKeys = [root.id + root.type];
    while (stack.length !== 0) {
      const node: any = stack.pop()!;
      this.visitNode(node, hashMap, array);
      if (node.subTrees) {
        node['children'] = node.subTrees;
        for (let i = node.children.length - 1; i >= 0; i--) {
          stack.push({
            ...node.children[i],
            level: node.level! + 1,
            title: node.children[i].name,
            type: node.children[i].type,
            key: node.children[i].id + node.children[i].type + node.id,
            expand: true,
            // head: node
          });
          if(this.treeFormControl.value) {
            this.defaultExpandedKeys = [...this.defaultExpandedKeys, node.children[i].id + node.children[i].type + node.id];
          }
        }
      }
    }

    return array;
  }
  addNodeVirtualInNodeParentHalfChecked(array: any) {
    if (array.length) {
      array.forEach((item) => {
        if(this.dataTreeSelected.length && this.treeFormControl.value) {
          if(!item.subTrees.filter((data) => data.id.includes('nodeVirtualIdChecked')).length) {
            item.subTrees.push(...[
              {
                id: 'nodeVirtualIdChecked' + item.id,
                name: 'node virtual checked',
                type: 'TYPE_VIRTUAL',
                isActive: true,
                subTrees: [],
                roleDTOS: null,
                parentId: item.id,
              },
              {
                id: 'nodeVirtualIdUnCheck' + item.id,
                name: 'node virtual uncheck',
                type: 'TYPE_VIRTUAL',
                isActive: true,
                subTrees: [],
                roleDTOS: null,
                parentId: item.id,
              }
            ]);
            this.dataVirtualCheckedKeys.push('nodeVirtualIdChecked' + item.id + 'TYPE_VIRTUAL' + item.id);
          }
        }
        if (item.subTrees && item.subTrees.length) {
          this.listDataTreeSelected.forEach((dataTreeSelected) => {
            item.subTrees.forEach(dataTree => {
              if (dataTreeSelected.parentId === dataTree.id) {
                if(!dataTree.subTrees.filter((data) => data.id.includes('nodeVirtualIdChecked')).length) {
                  dataTree.subTrees.push(...[
                    {
                      id: 'nodeVirtualIdChecked' + dataTree.id,
                      name: 'node virtual checked',
                      type: 'TYPE_VIRTUAL',
                      isActive: true,
                      subTrees: [],
                      roleDTOS: null,
                      parentId: dataTree.id,
                    },
                    {
                      id: 'nodeVirtualIdUnCheck' + dataTree.id,
                      name: 'node virtual uncheck',
                      type: 'TYPE_VIRTUAL',
                      isActive: true,
                      subTrees: [],
                      roleDTOS: null,
                      parentId: dataTree.id,
                    }
                  ]);
                  this.dataVirtualCheckedKeys.push('nodeVirtualIdChecked' + dataTree.id + 'TYPE_VIRTUAL' + dataTree.id);
                }
              }
            });
          })
        }
      })
    }
  }
  getDataTree() {
    this.sv.getTree().subscribe((rs) => {
      if (rs && rs.data) {
        const dataDocument = JSON.parse(JSON.stringify(rs.data));
        this.patchDataTreeToArray(dataDocument);
      }
    })
  }
  patchDataTreeToArray(data: any) {
    this.addNodeVirtual([data]);
    if(this.listDataTreeSelected.length) {
      this.addNodeVirtualInNodeParentHalfChecked([data]);
      this.defaultCheckedKeys = Array.from(new Set([...this.defaultCheckedKeys, ...this.dataVirtualCheckedKeys]));
    }

    [data].forEach((item: any) => {
      this.tempDataToTree = this.convertTreeToList(item).map((res) =>
        this.convertDataResponse(res)
      );
      this.defaultCheckedKeys = [...this.defaultCheckedKeys];

      this.featuresTree = [...this.listToTree(this.tempDataToTree)];
      setTimeout(() => {
        document.querySelectorAll('.hide-class').forEach((item) => {
          item.parentElement.parentElement.parentElement.classList.add('display-none');
        })
      }, 0);
    });

    if(data && data.subTrees.length) {
      data.subTrees.forEach((node) => {
        if(node.type === 'NODE_BETWEEN_USER') {
          this.infoNodeBetweenUser = { ...this.infoNodeBetweenUser, id: node.id, type: node.type };
        }
      });
    }
  }
  onSelectNode(event: NzFormatEmitEvent): void {
    this.isFormChanging = true;
    let keysDataTree: any[] = [];
    if(event.nodes && event.nodes.filter((node) => node.key.includes(event.node.origin.parentId + 'TYPE_VIRTUAL')).length) {
      event.nodes.find((node) => node.key.includes(event.node.origin.parentId + 'TYPE_VIRTUAL')).isChecked = false;
      if(event.nodes.find((node) => node.key.includes(event.node.origin.parentId + 'TYPE_VIRTUAL')).parentNode.children.length === 2) {
        event.nodes.find((node) => node.key.includes(event.node.origin.parentId + 'TYPE_VIRTUAL')).parentNode.isHalfChecked = false;
      }
      event.nodes = event.nodes.filter((node) => !node.key.includes(event.node.origin.parentId + 'TYPE_VIRTUAL'));
      event.keys = event.keys.filter((node) => !node.includes(event.node.origin.parentId + 'TYPE_VIRTUAL'));
      event.checkedKeys = event.checkedKeys.filter((node) => !node.key.includes(event.node.origin.parentId + 'TYPE_VIRTUAL'));
    }

    if(event.node.isChecked) {
      this.listDataTreeSelected.push({
        ...event.node.origin,
        parentType: event.node.parentNode ? event.node.parentNode.origin.type : null
      });
      if(event.node.children.length) {
        this.listDataTreeSelected.push(...event.node.children.map((data) => ({
          ...data.origin,
          parentType: event.node.parentNode ? event.node.parentNode.origin.type : null
        })));
      }
    } else {
      if((localStorage.getItem('isParent') == 'true' && event.node.origin.type === 'COMPANY') || (localStorage.getItem('isParent') == 'false' && event.node.origin.type === 'BRANCH')) {
        this.listDataTreeSelected = [...[]];
      }
      if(this.listDataTreeSelected.filter((node) => node.id === (event.node.parentNode ? event.node.parentNode.origin.id : null)).length) {
        this.listDataTreeSelected.push(...event.node.parentNode.children.map((data) => ({
          ...data.origin,
          parentType: event.node.parentNode ? event.node.parentNode.origin.type : null
        })));
      }
      if(event.node.children.length) {
        this.listDataTreeSelected.forEach((data) => {
          event.node.children.map((tree) => tree.origin).forEach((data2) => {
            if(data.id === data2.id) {
              this.listDataTreeSelected = [...this.listDataTreeSelected.filter((node) => node.id !== data2.id)];
            }
          })
        })
      }
      this.listDataTreeSelected = [...this.listDataTreeSelected.filter((data) => data.parentId !== event.node.origin.id)];

      if(localStorage.getItem('isParent') == 'true' && this.listDataTreeSelected.filter((data) => data.type === 'COMPANY').length) {
        this.listDataTreeSelected = [...this.listDataTreeSelected.filter((node) => node.type !== 'COMPANY')];
      }

      if(localStorage.getItem('isParent') == 'false' && this.listDataTreeSelected.filter((data) => data.type === 'BRANCH').length) {
        this.listDataTreeSelected = [...this.listDataTreeSelected.filter((node) => node.type !== 'BRANCH')];
      }

      this.listDataTreeSelected = [...this.listDataTreeSelected.filter((node) => node.id !== (event.node.parentNode ? event.node.parentNode.origin.id : null))];
      this.listDataTreeSelected = [...this.listDataTreeSelected.filter((node) => node.key !== event.node.origin.key)];
    }


    this.listDataTreeSelected = [...this.listDataTreeSelected.filter((data) => !data.id.includes('nodeVirtual'))];

    this.listDataTreeSelected = [...this.listDataTreeSelected.filter((value, index, self) =>
      index === self.findIndex((t) => (
        t.key === value.key && t.parentId === value.parentId
      ))
    )];

    keysDataTree = [...this.listDataTreeSelected];

    if(!this.listDataTreeSelected.length && this.dataVirtualCheckedKeys.length) {
      this.dataVirtualCheckedKeys = [...this.dataVirtualCheckedKeys.filter((key) => !key.includes('nodeVirtualIdChecked'))];
    }

    this.dataVirtualCheckedKeys = [...this.dataVirtualCheckedKeys.filter((key) => key !== 'nodeVirtualIdChecked' + event.node.origin.parentId + 'TYPE_VIRTUAL' + event.node.origin.parentId)];
    this.dataVirtualCheckedKeys = [...this.dataVirtualCheckedKeys.filter((key) => key !== 'nodeVirtualIdUnCheck' + event.node.origin.parentId + 'TYPE_VIRTUAL' + event.node.origin.parentId)];
    if(event.node.children.length) {
      this.dataVirtualCheckedKeys = [...this.dataVirtualCheckedKeys.filter((key) => key !== 'nodeVirtualIdChecked' + event.node.origin.id + 'TYPE_VIRTUAL' + event.node.origin.id)];
      this.dataVirtualCheckedKeys = [...this.dataVirtualCheckedKeys.filter((key) => key !== 'nodeVirtualIdUnCheck' + event.node.origin.id + 'TYPE_VIRTUAL' + event.node.origin.id)];
    }

    this.defaultCheckedKeys = [...Array.from(new Set([...keysDataTree.map((data) => data.key), ...this.dataVirtualCheckedKeys]))];


    if (this.listDataTreeSelected && this.listDataTreeSelected.length) {
      this.dataTreeSelected = this.listDataTreeSelected.map((node) => ({
        id: null,
        groupUserId: this.groupUserId,
        dataId: node.id,
        parentId: node.parentId ? node.parentId : null,
        dataType: node.type,
        parentType: node.parentType ? node.parentType : null
      }));
    } else {
      this.dataTreeSelected = [];
    }
  }
  visitNode(
    node: any,
    hashMap: { [key: string]: boolean },
    array: any[]
  ): void {
    const id = this.getNodeId(node);
    if (!hashMap[id]) {
      hashMap[id] = true;
    }
    array.push(node);
  }
  getNodeId(node: any) {
    if (node.id) {
      return node.id;
    }
    return node.companyId || '';
  }
  addNodeVirtual(array: any) {
    if(array.length) {
      array.forEach((item) => {
        if(item.subTrees && item.subTrees.length) {
          item.subTrees.push({
            id: 'nodeVirtualId' + (item.id ? item.id : ''),
            name: 'node virtual',
            type: 'TYPE_VIRTUAL',
            isActive: true,
            subTrees: [],
            roleDTOS: null,
            parentId: item.id,
          });
          this.addNodeVirtual(item.subTrees);
        }
      })
    }
  }
  convertDataResponse(data: any) {
    let newData: any = {};
    newData.title = data.name;
    newData.id = data.id;
    newData.level = data.level;
    newData.parentId = data.parentId;
    newData.key = data.key;
    newData.type = data.type;
    newData.children = data.children;
    newData.expanded = false;
    newData.isActive = data.isActive
    newData.isLeaf = !data.isParent;
    return newData;
  }
  listToTree(list: any[]) {
    if(localStorage.getItem('isParent') == 'true') {
      this.enterpriseType = 'COMPANY';
    } else {
      this.enterpriseType = 'BRANCH';
    }
    let map: any = {};
    let node: any;
    let roots: any[] = [];
    let i: number;

    for (i = 0; i < list.length; i += 1) {
      map[list[i].id] = i;
      list[i].children = [];
    }

    for (i = 0; i < list.length; i += 1) {
      node = list[i];
      if (node.type != this.enterpriseType && node.parentId) {
        list[map[node.parentId]].children.push(node);
      } else {
        roots.push(node);
      }
    }
    return roots;
  }
  beforeDrop(arg: NzFormatBeforeDropEvent): Observable<boolean> {
    if (arg.pos === 0) {
      return of(true).pipe(delay(0));
    } else {
      return of(false);
    }
  }
}
